<template>
  <section
    :class="[
      'user-center',
      'loginBtn-wrap',
      isMobile ? 'mobile' : 'desktop',
      type,
      isNewLayout ? 'new-version' : '',
      currentPage,
      layoutVersion,
      addClass ? addClass : '',
    ]"
    v-click-outside="onClickOutside"
  >
    <!-- 用户未登录 -->
    <section :class="['not-login', display]">
      <LoginPopover :page="currentPage" v-if="!userInfo">
        <button
          :class="[
            'login-btn',
            isMobile ? 'mobile' : 'desktop',
            display,
            currentPage,
          ]"
          @click="loginBtn"
        >
          {{ $t('common.login') }}
        </button>
      </LoginPopover>
    </section>

    <!-- 用户已登录 -->
    <div
      :class="[
        'user-info',
        isMobile ? 'mobile' : 'desktop',
        currentPage,
        display,
      ]"
      v-if="userInfo"
    >
      <LoginPopover
        :page="currentPage"
        ref="LoginPopoverRefs"
        @changeHasNewMessage="changeHasNewMessage"
      >
        <div @click="clickUserAvatar"><UserAvatar /></div>
      </LoginPopover>
    </div>
    <!-- 用户个人中心 -->
    <PopWrapper
      ref="popWrapper"
      :with-notice-bar="brandUpgradeNoticeVisible && !isDesktop"
    >
      <template #header>
        <div class="popup-header">
          <div class="popup-userInfo">
            <UserAvatar />
            <span class="popup-username">{{
              userInfo && userInfo.userName
            }}</span>
          </div>
        </div>
        <MemberShipModule />
        <BalanceCard :page="currentPage" :walletBalance="walletBalance" />
      </template>
      <template #content>
        <UserContent
          :currentPage="currentPage"
          :hasNewMessage="hasNewMessage"
          :newMessageNum="newMessageNum"
          @share="toShare"
          @message="onClickMessage"
        />
        <!-- <ClientDrainage v-if="isRenderAppBanner" entry="menu" /> -->
      </template>
    </PopWrapper>
    <MobileShare :currentPage="currentPage" ref="mobileShare" />
    <LoginBtn
      ref="loginComp"
      @login="login"
      :position="position"
      :parentContainer="parentContainer"
    />
    <WarningPopup ref="warningPopup" v-if="!inDetail" />
  </section>
</template>

<script>
  import Vue from 'vue'
  import MemberShipModule from '@/components/MembershipModule'
  import BalanceCard from '@/components/BalanceCard'
  import UserAvatar from '@/components/UserAvatar'
  import LoginPopover from '@/components/LoginPopover'
  import LoginBtn from '@/components/LoginBtn'
  import WarningPopup from '@/components/WarningPopup'
  import PopWrapper from './PopWrapper'
  // import ClientDrainage from '@/components/ClientDrainage'
  import UserContent from './UserContent'
  import bus from '@/utils/bus'
  import { autoLogin } from '@/api/login'
  import { LOGIN_TYPE } from '@/consts/index'
  import { getCurrentPage } from '@/utils/utils.js'
  import { Badge } from 'vant'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import { MobileShare } from '@/components/PublicShare/index'
  import { isMsaWebView, jumpBrowser } from '@/utils/msa'
  import { loginQuickSuccess, accountClick } from '@/pages/firebase'
  import '@/directives/clickOutside.js'

  Vue.use(Badge)

  export default {
    name: 'user-center',
    components: {
      MobileShare,
      MemberShipModule,
      BalanceCard,
      UserAvatar,
      LoginPopover,
      LoginBtn,
      WarningPopup,
      PopWrapper,
      UserContent,
      // ClientDrainage,
    },
    props: {
      addClass: {
        type: String,
        default: '',
      },
      page: {
        type: String,
        default: '',
      },
      display: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: '',
      },
      isAutoLogin: {
        type: Boolean,
        default: true,
      },
      needToTrackLogin: {
        type: Boolean,
        default: true,
      },
      position: {
        type: String,
        default: 'bottom',
      },
      parentContainer: {
        type: String,
      },
    },
    data() {
      return {
        hasNewMessage: false,
        newMessageNum: 0,
      }
    },
    watch: {
      userInfo: {
        handler(data) {
          const { name } = this.$route
          const pagesNeedToRequest = [
            'account',
            'AppSideBar',
            'expensesRecord',
            'Home',
            'password-edit',
            'payResult',
          ]
          // 钱包页和详情页中不用再次请求（引入 src/mixins/wallet中监听了 login）
          if (pagesNeedToRequest.indexOf(name) > -1 && data && data.kicoinId) {
            this.getWalletBalance()
          }
        },
        deep: true,
      },
    },
    computed: {
      ...mapState([
        'isDesktop',
        'isMobile',
        'userInfo',
        'paymentAccountInfo',
        'isTurbo',
        'layoutVersion',
        'region',
      ]),
      ...mapGetters([
        'isNew',
        'isNewLayout',
        'displayHorizontal',
        'isRenderAppBanner',
        'brandUpgradeNoticeVisible',
      ]),
      inDetail() {
        const { name } = this.$route
        return name === 'Detail2'
      },
      currentPage() {
        return getCurrentPage(this.$route.path)
      },
      versionClass() {
        return this.page === 'home' ? '' : this.isNewLayout ? 'new-version' : ''
      },
      walletBalance: {
        get() {
          // 从缓存中取钱包余额
          return (
            (this.paymentAccountInfo && this.paymentAccountInfo.amount) || 0
          )
        },
        set(val) {
          return val
        },
      },
    },
    created() {
      if (!process.client) return
    },
    async mounted() {
      if (this.isAutoLogin) {
        this.autoLoginFn()
      }
    },
    beforeDestroy() {
      bus.$off('autoLogin')
    },
    methods: {
      ...mapMutations(['setUserInfo', 'setLoginInfo']),
      ...mapActions(['getWalletBalance']),
      loginBtn(type) {
        // 用户如果在msa中，则点击登录时调用浏览器
        if (isMsaWebView()) {
          const isJump = jumpBrowser(window.location.href)
          if (isJump) return
        }
        this.$refs.loginComp && this.$refs.loginComp.loginBtn(type)
      },
      login(data) {
        this.$emit('login', data)
      },
      clickUserAvatar() {
        // 横屏不展示用户中心
        if (this.displayHorizontal) return
        this.$refs.popWrapper.show = true
        accountClick({ page: this.currentPage })
      },
      autoLoginFn() {
        this.setLoginInfo({ exe: 0, status: 0 })
        autoLogin()
          .then((res) => {
            const { kicoinToken } = res || {}
            if (kicoinToken) {
              bus.$emit('autoLogin', {
                status: 1,
                userInfo: res,
              })
              this.setLoginInfo({ exe: 1, status: 1 })
              this.setUserInfo(res)
              this.needToTrackLogin &&
                loginQuickSuccess({
                  page: this.currentPage,
                  mode: 0,
                  login_way: LOGIN_TYPE[res.loginType * 1],
                  button: 'login',
                })
              this.$emit('login', {
                status: 1,
                userInfo: res,
              })
              this.setLoginInfo({ exe: 1, status: 1 })
              return Promise.resolve(res)
            } else {
              this.$emit('login', {
                status: 0,
              })
              this.setLoginInfo({ exe: 1, status: 1 })
              return Promise.resolve(null)
            }
          })
          .catch(() => {
            this.$emit('login', {
              status: 0,
            })
            this.setLoginInfo({ exe: 1, status: 0 })
          })
      },
      changeHasNewMessage(data, newMessageNum) {
        this.hasNewMessage = data
        this.newMessageNum = newMessageNum
      },
      goto() {
        const { query = {} } = this.$route
        this.$router_push({
          path: '/myWallet',
          query,
        })
      },
      toShare() {
        this.$refs.popWrapper.show = false
        // 加延时是为了让 popWrapper 能先关闭
        setTimeout(() => {
          this.$refs.mobileShare && this.$refs.mobileShare.switch()
        }, 500)
      },
      onClickMessage() {
        this.$refs.LoginPopoverRefs &&
          this.$refs.LoginPopoverRefs.clickPopupList('message')
      },
      onClickOutside() {
        this.$refs.popWrapper.show = false
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
  ::v-deep .van-overlay {
    background: rgba(0, 0, 0, 0.5);
  }
  .user-info {
    &.id {
      .van-popup.van-popover.van-popover--light {
        .van-popover__content {
          width: 680px;
          .van-popover__action {
            height: 110px;
          }
        }
      }
    }
  }

  .user-center.desktop .pc-popover::v-deep .van-popover {
    .van-popover__arrow {
      display: none;
    }
    .van-popover__content {
      position: relative;
      top: 22px;
      border-radius: 0 0 15px 15px;
    }
  }
</style>
